class AddEditDocumentFolderController {
    /*@ngInject*/
    constructor($rootScope, MESSAGECONSTANTS, documentService, alertsAndNotificationsService) {
        this.$rootScope = $rootScope;
        this.MESSAGECONSTANTS = MESSAGECONSTANTS;
        this.documentService = documentService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
    }
    $onInit() {
        this.savingFlag = false;
        this.editingFolder = Object.assign({}, this.folder);
    }
    save() {
        this.documentFolderForm.$submitted = true;
        if (!this.documentFolderForm.$invalid) {
            if (this.folder.id) {
                if (((this.editingFolder.name != this.folder.name) && !this._isFolderNameDuplicate()) ||
                    ((this.editingFolder.name == this.folder.name) && (this.editingFolder.description != this.folder.description))) {
                    this.savingFlag = true;
                    this.documentService.updateCandidateDocumentFolder(this.folder, (data) => {
                        this._setFolder(data);
                    }, error => {
                        this.savingFlag = false;
                        this.alertsAndNotificationsService.showBannerMessage(error.message, "danger");
                    });
                }
                else if (((this.editingFolder.name != this.folder.name) && this._isFolderNameDuplicate())) {
                    this._showDuplicateMessageAlert();
                }
                else {
                    this.alertsAndNotificationsService.showBannerMessage('Nothing to update', "info");
                }
            }
            else {
                if (!this._isFolderNameDuplicate()) {
                    this.savingFlag = true;
                    this.documentService.addCandidateDocumentFolder(this.folder, (data) => {
                        this._setFolder(data);
                    }, error => {
                        this.savingFlag = false;
                        this.alertsAndNotificationsService.showBannerMessage(error.message, "danger");
                    });
                }
                else {
                    this._showDuplicateMessageAlert();
                }
            }
        }
    }
    _showDuplicateMessageAlert() {
        let title = "Duplicate Folder Name";
        let message = `Folder with name <b>'${this.folder.name}'</b> already exists. Please use another name.`;
        this.alertsAndNotificationsService.showAlert(title, message, "warning");
    }
    _setFolder(folder) {
        this.folder = folder;
        this.savingFlag = false;
        if (this.saveCallback) {
            this.saveCallback({ folder: this.folder });
        }
    }
    cancel() {
        if (this.cancelCallback) {
            this.cancelCallback();
        }
    }
    _isFolderNameDuplicate() {
        let isFolderNameExists = false;
        if (this.folders && this.folders.length > 0) {
            for (let i = 0; i < this.folders.length; i++) {
                let parentFolder = this.folders[i];
                if (parentFolder.name === this.folder.name) {
                    isFolderNameExists = true;
                    break;
                }
                else if (parentFolder.folders.length > 0) {
                    for (let j = 0; j < parentFolder.folders.length; j++) {
                        let childFolder = parentFolder.folders[j];
                        if (this.folder.name === childFolder.name) {
                            isFolderNameExists = true;
                            break;
                        }
                    }
                }
            }
        }
        ;
        return isFolderNameExists;
    }
}
AddEditDocumentFolderController.$inject = ['$rootScope', 'MESSAGECONSTANTS', 'documentService', 'alertsAndNotificationsService'];
// import * as TEMPLATE from './add-edit-document-folder.html';
import * as TEMPLATE from 'raw-loader!./add-edit-document-folder.html';
export const AddEditDocumentFolderComponent = {
    selector: 'addEditDocumentFolder',
    component: {
        bindings: {
            folder: '=',
            folders: '<',
            saveCallback: '&',
            cancelCallback: '&'
        },
        controller: AddEditDocumentFolderController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/candidateprofile/candidateProfile/candidateDocuments/addEditDocumentFolder/add-edit-document-folder.html'
    }
};
//# sourceMappingURL=add-edit-document-folder.component.js.map